import React, { useState, createContext, useContext } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

// Contexts
const AccordionContext = createContext();
const AccordionItemContext = createContext();

// Componente principal Accordion
export const Accordion = ({ children, type = 'single', collapsible = true, className = '' }) => {
  const [openItems, setOpenItems] = useState([]);

  const toggleItem = (value) => {
    if (type === 'single') {
      if (openItems.includes(value)) {
        setOpenItems(collapsible ? [] : [value]);
      } else {
        setOpenItems([value]);
      }
    } else {
      setOpenItems(prev => 
        prev.includes(value) 
          ? prev.filter(item => item !== value)
          : [...prev, value]
      );
    }
  };

  return (
    <AccordionContext.Provider value={{ openItems, toggleItem }}>
      <div className={className}>
        {children}
      </div>
    </AccordionContext.Provider>
  );
};

// Componente AccordionItem
export const AccordionItem = ({ children, value, className = '' }) => {
  return (
    <AccordionItemContext.Provider value={value}>
      <div className={className} data-value={value}>
        {children}
      </div>
    </AccordionItemContext.Provider>
  );
};

// Componente AccordionTrigger
export const AccordionTrigger = ({ children, className = '' }) => {
  const { openItems, toggleItem } = useContext(AccordionContext);
  const value = useContext(AccordionItemContext);
  const isOpen = openItems.includes(value);

  return (
    <button
      type="button"
      onClick={() => toggleItem(value)}
      className={`flex w-full items-center justify-between text-left ${className}`}
    >
      {children}
      <ChevronDown 
        className={`h-4 w-4 shrink-0 transition-transform duration-200 ${
          isOpen ? 'rotate-180' : ''
        }`}
      />
    </button>
  );
};

// Componente AccordionContent
export const AccordionContent = ({ children, className = '' }) => {
  const { openItems } = useContext(AccordionContext);
  const value = useContext(AccordionItemContext);
  const isOpen = openItems.includes(value);

  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
          className="overflow-hidden"
        >
          <div className={className}>
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
